import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Stabilise the state object so React doesn't see a new reference on every
    // render when this route is the navigation target.
    const navState = useMemo(
        () => ({ from: location.pathname }),
        [location.pathname]
    );

    if (isLoading) {
        return (
            <div
                className="flex min-h-screen items-center justify-center bg-background"
                data-testid="protected-route-loading"
            >
                <Loader2 className="h-6 w-6 animate-spin text-primary" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={navState} replace />;
    }

    return children;
};
